import { useDark } from "@vueuse/core"

const IS_DARK_MODE_AVAILABLE =
  import.meta.env.VITE_ORGANIZATION === "globalpay" &&
  import.meta.env.VITE_PLATFORM !== "web"

const isDark = useDark({
  valueDark: IS_DARK_MODE_AVAILABLE ? "dark" : "",
})

export const useDarkMode = () => ({
  isDarkModeAvailable: IS_DARK_MODE_AVAILABLE,
  isDark,
})
